import { DateTime } from "luxon";
import type { BookingScheduleInterface } from "../../features/Booking-Form/typings/booking.types";

/**
 * Own booking subject is editable only when the occurrence is still upcoming.
 * Colleague / company-admin past-running unlock stays on the caller via
 * `isColleagueScheduleEditable` (#1577).
 */
export function isOwnUpcomingBookingSubjectEditable({
  schedule,
  userSub,
  dialogEditable = true
}: {
  schedule: Pick<BookingScheduleInterface, "userBookedFor" | "startDate">;
  userSub: string;
  /** Parent dialog/popover “own booking editable” flag when present. */
  dialogEditable?: boolean;
}): boolean {
  return (
    dialogEditable &&
    schedule.userBookedFor === userSub &&
    DateTime.fromISO(schedule.startDate).valueOf() > DateTime.now().valueOf()
  );
}
